import Vue from 'vue'
import Router from 'vue-router'

/* eslint-disable no-multi-spaces */
import PageHome         from '@/components/pages/PageHome'
import PageImpressum    from '@/components/pages/PageImpressum'
import PageDatenschutz  from '@/components/pages/PageDatenschutz'
import PageLinks        from '@/components/pages/PageLinks'
import PageMakingOf     from '@/components/pages/PageMakingOf'
import PageContact       from '@/components/pages/PageContact'
// import PageBlog         from '@/components/pages/PageBlog' // Will be loaded dynamically on demand.
import PagePoCs         from '@/components/pages/PagePoCs'
import PageAboutMe      from '@/components/pages/PageAboutMe'
import PageLogoff       from '@/components/pages/PageLogoff'
import PageLogin        from '@/components/pages/PageLogin'
import PageRegister     from '@/components/pages/PageRegister'

Vue.use(Router)

/** Proceed (navigate) route only if browser is in a secure context (https:// or http://localhost) */
function proceedOnsecureContext (to, from, next) {
    if (window.location.protocol === 'https:' || window.location.hostname === 'localhost') {
        next()
    }
}

export default new Router({
    routes: [
        /* eslint-disable no-multi-spaces */
        /* eslint-disable object-property-newline */
        { path: '/',            name: 'Home',       component: PageHome },
        { path: '/impressum',   name: 'Impressum',  component: PageImpressum },
        { path: '/datenschutz', name: 'Datenschutz', component: PageDatenschutz },
        { path: '/links',       name: 'Links',      component: PageLinks },
        { path: '/makingof',    name: 'MakingOf',   component: PageMakingOf },
        { path: '/contact',     name: 'Kontakt',    component: PageContact },
        // { path: '/blog',        name: 'Blog',       component: PageBlog }, // Will be loaded dynamically on demand.
        { path: '/blog',        name: 'Blog',       component: () => import(/* webpackChunkName: "blog" */ '../components/pages/PageBlog.vue') },
        { path: '/PoCs',        name: 'PoCs',       component: PagePoCs },
        { path: '/AboutMe',     name: 'AboutMe',    component: PageAboutMe },
        { path: '/Login',       name: 'Login',      component: PageLogin,       beforeEnter: proceedOnsecureContext },
        { path: '/Logoff',      name: 'Logoff',     component: PageLogoff,      beforeEnter: proceedOnsecureContext },
        { path: '/Register',    name: 'Register',   component: PageRegister,    beforeEnter: proceedOnsecureContext }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js